import { getPublishingFile } from '@/shared/utils/publishingAsset';

/**
 * 외부 링크 모음.
 */
const FIVESPOT_APP_BASE_URL = 'https://fivespace.app.link';

export const EXTERNAL_LINKS = {
  // 약관 — TODO: 약관 스펙 확정 시 재검토 (URL·문구·백엔드 name/descriptionLink 일치 여부)
  // TODO: 현재 Notion 아웃링크(임시), 내부 퍼블리싱 페이지 확정 후 교체
  TERMS_OF_SERVICE:
    'https://fastfive.notion.site/35242271d1c5802cb873cac8b0cca7f1',
  // TODO: 내부 퍼블리싱 페이지로 교체 예정
  PRIVACY_AGREEMENT: 'https://fastfive.co.kr/privacy-policy',
  // TODO: 위치기반 서비스 이용약관 URL 확정 후 교체 (현재 임시값)
  LOCATION_AGREEMENT: 'https://www.naver.com',
  // TODO: 마케팅 활용 동의 약관 URL 확정 후 교체 (현재 임시값)
  MARKETING_AGREEMENT: 'https://www.naver.com',

  // FASTFIVE 본 사이트 (footer)
  FASTFIVE_INTRODUCTION_PDF: getPublishingFile(
    'pdf/global-eng/FASTFIVE_Introduction_Korean.pdf',
  ),
  FASTFIVE_GLOBAL_ENG: '/global-eng',
  FASTFIVE_PRIVACY_POLICY: '/privacy-policy',
  // 광고 소개서
  AD_INTRODUCTION_PDF: getPublishingFile(
    'pdf/%5BFIVEAD%5D%20Service%20Introduction.pdf',
  ),

  // 문의 폼 (footer)
  PARTNERSHIP_INQUIRY: 'https://form.jotform.com/213291493874060',
  BUILDING_INQUIRY:
    'https://buildingsolution.co.kr?utm_source=fastfive.co.kr&utm_medium=referral',
  AD_INQUIRY:
    'https://form.jotform.com/252500654695056?utm_source=fastfive.co.kr&utm_medium=referral',

  // 채용
  CAREER: 'https://fastfive.career.greetinghr.com',

  // 패밀리 사이트 (footer selectbox)
  FAMILY_FIVESPOT: 'https://fivespot.io',
  FAMILY_HYPHEN_DESIGN: 'https://hyphendesign.co.kr',
  FAMILY_FIVECLOUD: 'https://fivecloud.co.kr',
  FAMILY_BUILDING_SOLUTION: 'https://buildingsolution.co.kr',
  FAMILY_OPEN_SPACE: 'https://open-space.fastfive.co.kr',
  FAMILY_CREDIT: 'https://members.fastfive.co.kr/subscriptions',

  // 소셜 (footer)
  SOCIAL_FACEBOOK: 'https://www.facebook.com/ftfive/',
  SOCIAL_INSTAGRAM: 'https://www.instagram.com/fastfive_official',
  // handle URL 로 통일 (기존 channel ID URL 과 동일 채널).
  SOCIAL_YOUTUBE: 'https://www.youtube.com/@FASTFIVEOFFICIAL',
  SOCIAL_NAVER_BLOG: 'https://blog.naver.com/fast_five_',
  SOCIAL_BRUNCH: 'https://brunch.co.kr/@fastfive',
  SOCIAL_LINKEDIN: 'https://www.linkedin.com/company/fastfive/',

  // 라운지 멤버십
  LOUNGE_MEMBERSHIP: 'https://fivespot.io/pass',
  FIVESPOT_WEB:
    process.env.NEXT_PUBLIC_FIVESPOT_WEB_URL ?? 'https://fivespot.io',
  // 파이브스팟 앱 딥링크 — 앱 설치 시 앱으로, 미설치 시 웹으로 폴백된다.
  FIVESPOT_APP: `${FIVESPOT_APP_BASE_URL}/home`,

  // 패파트너 프로그램
  FF_PARTNER_PROGRAM: '/ff-partners',
  // 주문서 약관 — TODO: fivespot oopy 아웃링크(임시), fastfive 자체 약관 페이지 확정 후 교체
  LOUNGE_MEMBERSHIP_TERMS: 'https://fivespot.oopy.io/membership-terms',
  LOUNGE_REFUND_POLICY: 'https://fivespot.oopy.io/refund-policy',
} as const;

export function getFivespotPassDetailAppLink(contractId: number) {
  const searchParams = new URLSearchParams({
    to: 'PCD',
    contractId: String(contractId),
  });

  return `${FIVESPOT_APP_BASE_URL}/kakao?${searchParams}`;
}
